import { render } from "./TheMenu.vue?vue&type=template&id=feabe88a&scoped=true&ts=true"
import script from "./TheMenu.vue?vue&type=script&lang=ts"
export * from "./TheMenu.vue?vue&type=script&lang=ts"

import "./TheMenu.vue?vue&type=style&index=0&id=feabe88a&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feabe88a"]])

export default __exports__